// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__7jPap","shineButton":"Hero_shineButton__ERCDQ","shine":"Hero_shine__cg2bu"};